import { handleRecordClick } from './vmTrackingHandler';

export function gtmPageView(gtmEventName) {
  let dataLayer = window ? window.dataLayer : null;
  if (dataLayer) {
    dataLayer.push({
      'event': 'VirtualPageview',
      'virtualPageURL': `/virtual/${gtmEventName}`,
      'virtualPageTitle': gtmEventName,
    });
  }
}

export function gtmAlert(gtmEventName) {
  let dataLayer = window ? window.dataLayer : null;
  if (dataLayer) {
    dataLayer.push({
      'event': gtmEventName,
    });
  }
}

export function gtmUserIdTrigger(userId) {
  let dataLayer = window ? window.dataLayer : null;
  if (dataLayer) {
    dataLayer.push({
      'user_id': userId,
    });
  }
}

export function gtmCustomEvent(category, action, label) {
  let dataLayer = window ? window.dataLayer : null;
  if (dataLayer) {
    dataLayer.push({
      'event': 'customEventTrigger',
      'customEventCategory' : category,
      'customEventAction' : action,
      'customEventLabel' : label,
    });
  }
  let url = '';
  if(window && window.location && window.location.pathname) {
    url = window.location.pathname;
  }
  handleRecordClick(category, action, label, label, url);
}
